import { Component } from '@angular/core';

@Component({
  selector: 'itl-warning-item',
  templateUrl: './warning-item.component.html',
  styleUrls: ['./warning-item.component.scss'],
})
export class WarningItemComponent {}
